import type { SendEmailForCallbackMutationRequest } from '@/api/kubik/credit'
import type { IFinancingCallbackForm } from './types'

export const getRequestBodyForCallbackRequest = (
  formValue: IFinancingCallbackForm,
  contextOfRequest: string,
): SendEmailForCallbackMutationRequest => {
  return { ...formValue, comment: contextOfRequest }
}
